export enum SshKeyStatus {
    PENDING = 'pending',
    ACTIVE = 'active',
    REVOKED = 'revoked',
    REJECTED = 'rejected',
}
